import React from 'react';

// The song's title and artist ride in the sticky top band beside the logo - the
// same spot the controls occupy on the home and chords pages.
const Title = ({ artist, title }: TitleProps) => (
	<div className="top-nav bottom-border">
		<div className="song-header">
			<span className="song-header__title">{title}</span>
			<span className="song-header__artist">by {artist}</span>
		</div>
	</div>
);

type TitleProps = {
	artist: string;
	title: string;
};

export default Title;
